import { ChangeDetectionStrategy, Component, Input } from '@angular/core';


@Component({
    selector: 'legal-affiliate-terms',
    templateUrl: './affiliate-terms.component.html',
    styleUrls: ['./affiliate-terms.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LegalAffiliateTermsComponent {

	//** Input Decorators */
	@Input() content!: string;
}
